/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_CopiedInputs */

const en_us2_invite_copied = /** @type {(inputs: Invite_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code copied`)
};

const pt_br2_invite_copied = /** @type {(inputs: Invite_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código copiado`)
};

const pt_pt2_invite_copied = /** @type {(inputs: Invite_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código copiado`)
};

/** @type {(inputs: Invite_CopiedInputs) => LocalizedString} */
const es_419_invite_copied = en_us2_invite_copied;

/** @type {(inputs: Invite_CopiedInputs) => LocalizedString} */
const fr_fr2_invite_copied = en_us2_invite_copied;

/** @type {(inputs: Invite_CopiedInputs) => LocalizedString} */
const de_de2_invite_copied = en_us2_invite_copied;

/** @type {(inputs: Invite_CopiedInputs) => LocalizedString} */
const it_it2_invite_copied = en_us2_invite_copied;

/**
* | output |
* | --- |
* | "Code copied" |
*
* @param {Invite_CopiedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_copied = /** @type {((inputs?: Invite_CopiedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_CopiedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_copied(inputs)
	if (locale === "es-419") return es_419_invite_copied(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_copied(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_copied(inputs)
	if (locale === "de-DE") return de_de2_invite_copied(inputs)
	if (locale === "it-IT") return it_it2_invite_copied(inputs)
	return en_us2_invite_copied(inputs)
});
export { invite_copied as "invite.copied" }